import VueRouter from "vue-router";

const routes = [
  // Redirect to home if 404
  { path: "*", redirect: "/" },
  {
    path: "/",
    name: "home",
    meta: {
      title: "Home",
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
  },
  {
    path: "/discography",
    name: "music",
    meta: {
      title: "Music",
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/Discography.vue"),
  },
  {
    path: "/tour",
    name: "tour",
    meta: {
      title: "Tour",
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/TourView.vue"),
  },
  {
    path: "/shop",
    name: "shop",
    meta: {
      title: "Merch",
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/ShopView.vue"),
  },
  {
    path: "/about-us",
    name: "band",
    meta: {
      title: "Band",
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/AboutUs.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    meta: {
      title: "Contact Us!",
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/ContactView.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
